export enum EFrekvenceVyplaty {
    A = 'A',
    S = 'S',
    Q = 'Q',
    M = 'M',
    W = 'W',
    D = 'D',
    B = 'B',
    X = 'X',
    NA = 'NA'
}
